export const fightSimulatorRuleLocalization = {
  ko: {
    FightSimulator: {
      // 프로덕트 설명
      title: "야차 시뮬레이션",
      description: "AI가 두 사람의 싸움 결과를 예측합니다",

      // 입력 폼
      name: "이름",
      namePlaceholder: "이름을 입력하세요",
      height: "키",
      weight: "몸무게",
      age: "나이",
      years: "세",
      gender: "성별",
      male: "남성",
      female: "여성",

      // 격투 경력
      martialArts: "격투 경력",
      martialArtTypePlaceholder: "종목 (복싱, MMA 등)",
      months: "개월",

      // 체력/경험
      fitnessLevel: "체력 수준",
      fitnessHigh: "상",
      fitnessMedium: "중",
      fitnessLow: "하",
      realFightExperience: "실전 경험",

      // 헬스
      healthExperience: "헬스 경력",
      yearsOfTraining: "헬스 경력 (년)",
      benchPress: "벤치",
      deadlift: "데드",
      squat: "스쿼트",

      // 유산소
      cardioExperience: "유산소 운동",
      maxRunningDistance: "최대 러닝 거리",

      // 시뮬레이션
      startSimulation: "시뮬레이션 시작",
      simulating: "AI가 분석 중...",

      // 결과
      result: "결과",
      predictedWinner: "예상 승자",
      draw: "무승부",
      fightStory: "싸움 스토리",
      keyFactors: "주요 승부 요인",

      // 버튼
      retry: "다시 하기",
      newMatch: "새로운 매치",

      // 에러
      errorGeneric: "시뮬레이션 중 오류가 발생했습니다. 다시 시도해주세요.",

      // 규칙 (RuleBody용)
      rules: [
        // Page 0: 사용 방법
        "Fighter A 정보 입력",
        "첫 번째 대결자의 신체 정보와 격투 경력을 입력하세요",
        "Fighter B 정보 입력",
        "두 번째 대결자의 신체 정보와 격투 경력을 입력하세요",
        "시뮬레이션 시작",
        "AI가 두 사람의 정보를 분석하여 싸움 결과를 예측합니다",

        // Page 1: 입력 항목
        "입력 항목",
        "키, 몸무게, 나이, 성별",
        "격투 경력 (종목, 수련 기간)",
        "체력 수준 (상/중/하)",
        "실전 경험 유무",
        "주의사항",
        "이 결과는 재미를 위한 것이며 실제 싸움을 권장하지 않습니다",
      ],
    },
  },
  en: {
    FightSimulator: {
      // Product description
      title: "Fight Simulator",
      description: "AI predicts the outcome of a fight between two people",

      // Input form
      name: "Name",
      namePlaceholder: "Enter name",
      height: "Height",
      weight: "Weight",
      age: "Age",
      years: "yrs",
      gender: "Gender",
      male: "Male",
      female: "Female",

      // Martial arts
      martialArts: "Martial Arts",
      martialArtTypePlaceholder: "Type (Boxing, MMA, etc.)",
      months: "mo",

      // Fitness/Experience
      fitnessLevel: "Fitness Level",
      fitnessHigh: "High",
      fitnessMedium: "Medium",
      fitnessLow: "Low",
      realFightExperience: "Real Fight Experience",

      // Health
      healthExperience: "Gym Experience",
      yearsOfTraining: "Years of Training",
      benchPress: "Bench Press",
      deadlift: "Deadlift",
      squat: "Squat",

      // Cardio
      cardioExperience: "Cardio Experience",
      maxRunningDistance: "Max Running Distance",

      // Simulation
      startSimulation: "Start Simulation",
      simulating: "AI is analyzing...",

      // Result
      result: "Result",
      predictedWinner: "Predicted Winner",
      draw: "Draw",
      fightStory: "Fight Story",
      keyFactors: "Key Factors",

      // Buttons
      retry: "Try Again",
      newMatch: "New Match",

      // Error
      errorGeneric: "An error occurred during simulation. Please try again.",

      // Rules (for RuleBody)
      rules: [
        // Page 0: How to use
        "Enter Fighter A Info",
        "Input the first fighter's physical info and martial arts experience",
        "Enter Fighter B Info",
        "Input the second fighter's physical info and martial arts experience",
        "Start Simulation",
        "AI analyzes both fighters' info to predict the fight outcome",

        // Page 1: Input fields
        "Input Fields",
        "Height, weight, age, gender",
        "Martial arts experience (type, duration)",
        "Fitness level (high/medium/low)",
        "Real fight experience",
        "Disclaimer",
        "This is for entertainment purposes only and does not encourage actual fighting",
      ],
    },
  },
};
